import { useState } from "react";
import { Ellipsis, KeyRound, Pencil, Trash2 } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ACL_RELATIONSHIPS from "acl-relationships";
import useAuthorized from "hooks/useAuthorized";
import AccountAuthenticationModal from "routes/constant_contact/components/AccountAuthenticationModal";
import AccountModal from "routes/constant_contact/components/AccountModal";
import DeleteAccountModal from "routes/constant_contact/components/DeleteAccountModal";

export function AccountsTableActions({ original }) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);

  const canEdit = useAuthorized([
    ACL_RELATIONSHIPS.constantContactAccounts.edit,
  ]);
  const canDelete = useAuthorized([
    ACL_RELATIONSHIPS.constantContactAccounts.delete,
  ]);
  const canAuth = useAuthorized([
    ACL_RELATIONSHIPS.constantContactAccounts.auth,
    ACL_RELATIONSHIPS.constantContactAccounts.edit,
  ]);

  if (!canEdit && !canDelete && !canAuth) return null;

  const isAuthenticated = original.authentication_status === "authenticated";

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Account actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:min-w-44">
          {canAuth && (
            <DropdownMenuItem onClick={() => setAuthOpen(true)}>
              <KeyRound />
              {isAuthenticated ? "Re-Authenticate" : "Authenticate"}
            </DropdownMenuItem>
          )}
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      {canEdit && (
        <AccountModal
          account={original}
          open={editOpen}
          onOpenChange={setEditOpen}
        />
      )}
      {canDelete && (
        <DeleteAccountModal
          account={original}
          open={deleteOpen}
          onOpenChange={setDeleteOpen}
        />
      )}
      {canAuth && (
        <AccountAuthenticationModal
          account={original}
          open={authOpen}
          onOpenChange={setAuthOpen}
        />
      )}
    </>
  );
}
